import React, { useLayoutEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import axios from "axios";
import { DB_HOST, ENDP_PORT } from "../global_variables";
import { API_IP, GOOGLE_API_KEY } from "../global_variables";
import { randomNumber } from "../functions/RandomNumber";
import toast from "react-hot-toast";
import Autocomplete from "react-google-autocomplete";
import { trackEvent } from "../lib/metaPixel";
import "./Auth.css";

// Format names so that the first letter is upper-case and the rest are lower-case.
function formatName(name) {
  if (!name) return "";

  return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
}

// Registration.js is three pages of registration.
// This is a consistent title for these pages.
const RegistrationTitle = () => (
  <div className="AuthHeader">
    <h1>Create your account</h1>
    <p>Set up your profile in a few quick steps.</p>
  </div>
);

// The first page of registration.
const Registration1 = ({ registrationData, setRegistrationData }) => {
  const navigate = useNavigate();

  useEffect(() => {
    console.log("Updated registration data:", registrationData);
  }, [registrationData]);

  // RegEx variables.
  let nameRegex = /^.{2,}$/;
  let emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  let passwordRegex = /^.{2,}$/;
  let hasEmail = false;

  // What to do when the next button is clicked.
  const handleNextButtonClick = async (e) => {
    e.preventDefault();

    let fName = document.getElementById("firstName").value;
    let lName = document.getElementById("lastName").value;
    let email = document.getElementById("email").value;
    let password = document.getElementById("password").value;
    let passwordConfirm = document.getElementById("passwordConfirm").value;
    let isValid = true;

    // Make sure names start with upper-case and the rest are lower-case.
    if (fName != null) fName = formatName(fName);
    if (lName != null) lName = formatName(lName);

    try {
      const url = `${API_IP}/api/accountCheck/?email=${email.toLowerCase()}`;
      const { data } = await axios.get(url);
      hasEmail = data;
      if (hasEmail) {
        document.getElementById("emailExists").style.visibility = "visible";
        isValid = false;
      } else {
        document.getElementById("emailExists").style.visibility = "hidden";
      }
    } catch (error) {
      console.log(error);
    }

    //test if the name is valid
    if (!nameRegex.test(fName)) {
      document.getElementById("firstNameError").style.visibility = "visible";
      isValid = false;
    } else {
      document.getElementById("firstNameError").style.visibility = "hidden";
    }

    // test the last name
    if (!nameRegex.test(lName)) {
      document.getElementById("lastNameError").style.visibility = "visible";
      isValid = false;
    } else {
      document.getElementById("lastNameError").style.visibility = "hidden";
    }

    // test the email field
    // need to check if the email is at the database
    if (!emailRegex.test(email)) {
      document.getElementById("emailError").style.visibility = "visible";
      isValid = false;
    } else {
      document.getElementById("emailError").style.visibility = "hidden";
    }

    //test the password field, regex implies that needs to be longer than 1 character
    if (password === "" || passwordConfirm === "") {
      document.getElementById("samePasswordError").innerText =
        "Password fields cannot be empty";
      document.getElementById("samePasswordError").style.visibility = "visible";
      isValid = false;
    } else if (password !== passwordConfirm) {
      document.getElementById("samePasswordError").innerText =
        "Passwords do not match";
      document.getElementById("samePasswordError").style.visibility = "visible";
      isValid = false;
    } else if (!passwordRegex.test(password)) {
      document.getElementById("passwordError").innerText =
        "Invalid password. It must be longer than 1 character.";
      document.getElementById("passwordError").style.visibility = "visible";
      isValid = false;
    } else {
      document.getElementById("samePasswordError").style.visibility = "hidden";
      document.getElementById("passwordError").style.visibility = "hidden";
    }
    console.log(password, 888);
    //do validation later

    if (!isValid) {
      return;
    }

    // Put registration into into a JSON object.
    const registerInfoPart1 = {
      "first-name": fName,
      "last-name": lName,
      email: email,
      password: password,
    };

    setRegistrationData((prevData) => ({
      ...prevData,
      ...registerInfoPart1,
    }));

    // console.log('Step 1 data:', registerInfoPart1);
    // console.log(registrationData);

    navigate("/register/registration2");
  };

  return (
    <form className="AuthForm" onSubmit={handleNextButtonClick}>
      <div className="AuthStep">
        <span className="AuthStepBadge">Step 1 of 3</span>
        <span className="AuthStepText">Basic info</span>
      </div>

      <div className="AuthFormGrid">
        <div className="AuthField">
          <label htmlFor="firstName">First name</label>
          <input
            id="firstName"
            type="text"
            name="first-name"
            placeholder="Jane"
            autoComplete="given-name"
          />
        </div>
        <div className="AuthField">
          <label htmlFor="lastName">Last name</label>
          <input
            id="lastName"
            type="text"
            name="last-name"
            placeholder="Doe"
            autoComplete="family-name"
          />
        </div>
      </div>

      <div className="AuthField">
        <label htmlFor="email">Email</label>
        <input
          id="email"
          type="email"
          name="email-address"
          placeholder="jane.doe@gmail.com"
          autoComplete="email"
        />
      </div>

      <div className="AuthFormGrid">
        <div className="AuthField">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            name="password"
            placeholder="Create a password"
            autoComplete="new-password"
          />
        </div>
        <div className="AuthField">
          <label htmlFor="passwordConfirm">Confirm password</label>
          <input
            id="passwordConfirm"
            type="password"
            name="confirm-password"
            placeholder="Re-enter password"
            autoComplete="new-password"
          />
        </div>
      </div>

      <ul className="errorOutput">
        <li
          id="firstNameError"
          className="firstNameError"
          style={{ visibility: "hidden", color: "red" }}
        >
          Invalid first name, field cannot be empty
        </li>
        <li
          id="lastNameError"
          className="lastNameError"
          style={{ visibility: "hidden", color: "red" }}
        >
          Invalid last name, field cannot be empty
        </li>
        <li
          id="emailError"
          className="emailError"
          style={{ visibility: "hidden", color: "red" }}
        >
          Invalid email address. format (janedoe@gmail.com)
        </li>
        <li
          id="passwordError"
          className="passwordError"
          style={{ visibility: "hidden", color: "red" }}
        ></li>
        <li
          id="samePasswordError"
          className="samePasswordError"
          style={{ visibility: "hidden", color: "red" }}
        ></li>
        <li
          id="emailExists"
          className="emailExists"
          style={{ visibility: "hidden", color: "red" }}
        >
          Email Already in use, maybe try to log in
        </li>
      </ul>
      <button type="submit" className="AuthPrimaryButton">
        Continue
      </button>

      <div className="AuthFooter">
        <div className="AuthFooterRow">
          <span>Already have an account?</span>
          <a className="AuthLink" href="/login">
            Sign in
          </a>
        </div>
      </div>
    </form>
  );
};

// The second page of registration.
const Registration2 = ({ registrationData, setRegistrationData }) => {
  const navigate = useNavigate();

  let phoneRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  let addressRegex = /^[a-zA-Z0-9\s,.'-]{3,}$/;
  let cityRegex = /^[a-zA-Z\s'-]{2,}$/;
  let provinceRegex = /^[a-zA-Z\s'-]{2,}$/;
  let postalCodeRegex = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;

  const handleNextButtonClick = (e) => {
    e.preventDefault();

    let phoneNumber = parseInt(document.getElementById("phoneNumber").value);
    let address = document.getElementById("address").value;
    let address2 = document.getElementById("address2").value;
    let city = document.getElementById("city").value;
    let province = document.getElementById("province").value;
    let postalCode = document.getElementById("postalCode").value;
    let isValid = true;

    if (!phoneRegex.test(phoneNumber)) {
      document.getElementById("phoneFormatError").style.visibility = "visible";
      isValid = false;
    } else {
      document.getElementById("phoneFormatError").style.visibility = "hidden";
    }

    // Validate address
    if (!addressRegex.test(address)) {
      document.getElementById("addressFormatError").style.visibility =
        "visible";
      isValid = false;
    } else {
      document.getElementById("addressFormatError").style.visibility = "hidden";
    }

    // Validate city
    if (!cityRegex.test(city)) {
      document.getElementById("cityFormatError").style.visibility = "visible";
      isValid = false;
    } else {
      document.getElementById("cityFormatError").style.visibility = "hidden";
    }

    // Validate province
    if (!provinceRegex.test(province)) {
      document.getElementById("provinceFormatError").style.visibility =
        "visible";
      isValid = false;
    } else {
      document.getElementById("provinceFormatError").style.visibility =
        "hidden";
    }

    // Validate postal code
    if (!postalCodeRegex.test(postalCode)) {
      document.getElementById("postalCodeFormatError").style.visibility =
        "visible";
      isValid = false;
    } else {
      document.getElementById("postalCodeFormatError").style.visibility =
        "hidden";
    }

    if (!isValid) {
      return;
    }

    const newRegistrationData = {
      phoneNumber,
      address,
      address2,
      city,
      province,
      postalCode,
    };

    setRegistrationData((prevData) => ({
      ...prevData,
      ...newRegistrationData,
    }));

    console.log("Step 2 data:", newRegistrationData);
    console.log(registrationData);

    navigate("/register/registration3");
  };

  const handleBackButtonClick = () => {
    navigate("/register/registration1");
  };

  const handlePlaceSelected = (place) => {
    if (!place || !place.address_components) return;

    let streetNumber = "";
    let route = "";
    let city = "";
    let province = "";
    let postalCode = "";

    place.address_components.forEach((component) => {
      const types = component.types || [];
      if (types.includes("street_number")) streetNumber = component.long_name;
      if (types.includes("route")) route = component.long_name;
      if (types.includes("locality")) city = component.long_name;
      if (types.includes("administrative_area_level_1"))
        province = component.short_name || component.long_name;
      if (types.includes("postal_code")) postalCode = component.long_name;
    });

    const line1 =
      (streetNumber && route ? `${streetNumber} ${route}` : place.name || "")
        .trim();

    const addressEl = document.getElementById("address");
    const cityEl = document.getElementById("city");
    const provinceEl = document.getElementById("province");
    const postalEl = document.getElementById("postalCode");

    if (addressEl && line1) addressEl.value = line1;
    if (cityEl && city) cityEl.value = city;
    if (provinceEl && province) provinceEl.value = province;
    if (postalEl && postalCode) postalEl.value = postalCode;
  };

  return (
    <form className="AuthForm" onSubmit={handleNextButtonClick}>
      <div className="AuthStep">
        <span className="AuthStepBadge">Step 2 of 3</span>
        <span className="AuthStepText">Contact details</span>
      </div>

      <div className="AuthField">
        <label htmlFor="phoneNumber">Phone number</label>
        <input
          id="phoneNumber"
          type="tel"
          name="phone-number"
          placeholder="(250) 555-1234"
          autoComplete="tel"
        />
      </div>

      <div className="AuthField">
        <label htmlFor="address">Address</label>
        <Autocomplete
          apiKey={GOOGLE_API_KEY}
          id="address"
          options={{
            types: ["address"],
            componentRestrictions: { country: "ca" },
          }}
          onPlaceSelected={handlePlaceSelected}
          placeholder="123 Main St"
          className="AuthAutoInput"
        />
      </div>

      <div className="AuthField">
        <label htmlFor="address2">Address line 2 (optional)</label>
        <input
          id="address2"
          type="text"
          name="address2"
          placeholder="Unit / Apt / Suite"
          autoComplete="address-line2"
        />
      </div>

      <div className="AuthFormGrid">
        <div className="AuthField">
          <label htmlFor="city">City</label>
          <input
            id="city"
            type="text"
            name="city"
            placeholder="Victoria"
            autoComplete="address-level2"
          />
        </div>
        <div className="AuthField">
          <label htmlFor="province">Province</label>
          <input
            id="province"
            type="text"
            name="province"
            placeholder="BC"
            autoComplete="address-level1"
          />
        </div>
      </div>

      <div className="AuthField">
        <label htmlFor="postalCode">Postal code</label>
        <input
          id="postalCode"
          type="text"
          name="postal-code"
          placeholder="V5K 0A1"
          autoComplete="postal-code"
        />
      </div>

      <ul className="errorOutput">
        <li
          id="phoneFormatError"
          className="phoneFormatError"
          style={{ visibility: "hidden", color: "red" }}
        >
          Your phone number doesn't appear to be valid.
          <br />
          Please try to enter it again.
        </li>
        <li
          id="addressFormatError"
          className="addressFormatError"
          style={{ visibility: "hidden", color: "red" }}
        >
          Your address doesn't appear to be valid.
          <br />
          Please try to enter it again.
        </li>
        <li
          id="cityFormatError"
          className="cityFormatError"
          style={{ visibility: "hidden", color: "red" }}
        >
          Your city doesn't appear to be valid.
          <br />
          Please try to enter it again.
        </li>
        <li
          id="provinceFormatError"
          className="provinceFormatError"
          style={{ visibility: "hidden", color: "red" }}
        >
          Your province doesn't appear to be valid.
          <br />
          Please try to enter it again.
        </li>
        <li
          id="postalCodeFormatError"
          className="postalCodeFormatError"
          style={{ visibility: "hidden", color: "red" }}
        >
          Your postal code doesn't appear to be valid. Format V1V 1V1
          <br />
          Please try to enter it again.
        </li>
      </ul>
      <div className="AuthActionsRow">
        <button
          type="button"
          className="AuthSecondaryButton"
          onClick={handleBackButtonClick}
        >
          Back
        </button>
        <button type="submit" className="AuthPrimaryButton">
          Continue
        </button>
      </div>
    </form>
  );
};

// The third page of registration.
const Registration3 = ({ registrationData }) => {
  const navigate = useNavigate();
  let currentYear = parseInt(new Date().getFullYear());
  let usernameRegex = /^.{2,}$/;
  let isValid = true;
  let hasEmail = false;
  // eslint-disable-next-line no-const-assign

  const handleBackButtonClick = () => {
    navigate("/register/registration2");
  };

  const handleFinishButtonClick = async (e) => {
    e.preventDefault();
    const username = document.getElementById("username").value;

    if (!usernameRegex.test(username)) {
      document.getElementById("usernameError").style.visibility = "visible";
      isValid = false;
    } else {
      document.getElementById("usernameError").style.visibility = "hidden";
    }

    try {
      const url = `${API_IP}/api/accountCheck/?email=${username.toLowerCase()}`;
      const { data } = await axios.get(url);
      hasEmail = data;
      if (hasEmail) {
        document.getElementById("usernameExists").style.visibility = "visible";
        isValid = false;
      } else {
        document.getElementById("usernameExists").style.visibility = "hidden";
      }
    } catch (error) {
      console.log(error);
    }

    if (!isValid) {
      return;
    }

    const url = `${API_IP}/api/account`;
    const payload = {
      username: username, // assuming username is defined elsewhere
      email: registrationData.email,
      year: parseInt(currentYear), // assuming currentYear is defined elsewhere
      phone_number: registrationData.phoneNumber,
      password: registrationData.password,
    };

    try {
      const { data } = await axios.post(url, payload);
      console.log(data);
      trackEvent("CompleteRegistration", { status: true });
    } catch (error) {
      console.error(error);
    }
    toast.success(
      "Registration successful! Check your email for verification. If you don't see it, check your spam folder."
    );
    navigate("/login");
  };

  return (
    <form className="AuthForm" onSubmit={handleFinishButtonClick}>
      <div className="AuthStep">
        <span className="AuthStepBadge">Step 3 of 3</span>
        <span className="AuthStepText">Choose a username</span>
      </div>

      <div className="AuthField">
        <label htmlFor="username">Username</label>
        <input
          id="username"
          type="text"
          name="username"
          placeholder="jane_doe"
          autoComplete="username"
        />
      </div>

      <div className="AuthActionsRow">
        <button
          type="button"
          className="AuthSecondaryButton"
          onClick={handleBackButtonClick}
        >
          Back
        </button>
        <button type="submit" className="AuthPrimaryButton">
          Finish
        </button>
      </div>
      <ul className="errorOutput">
        <li
          id="usernameError"
          className="usernameError"
          style={{ visibility: "hidden", color: "red" }}
        >
          Your username doesn't appear to be valid. Cannot be empty
          <br />
          Please try to enter it again.
        </li>
        <li
          id="usernameExists"
          className="usernameExists"
          style={{ visibility: "hidden", color: "red" }}
        >
          Username already in use
        </li>
      </ul>
    </form>
  );
};

// The main component that consolidates and controlls the registration pages.
// If you need to add a page, make a new component for it and add it to the routing table. Make sure to check that Links work.
const Registration = () => {
  const [registrationData, setRegistrationData] = useState({});
  const imageNumber = randomNumber();
  console.log("imageNumber: " + imageNumber);
  const paneRef = useRef(null);
  const [paneHeight, setPaneHeight] = useState(null);

  useLayoutEffect(() => {
    const el = paneRef.current;
    if (!el) return;
    const measure = () => setPaneHeight(el.scrollHeight);
    measure();
    const ro = new ResizeObserver(() => measure());
    ro.observe(el);
    return () => ro.disconnect();
  }, [registrationData]);

  return (
    <>
      <div className="contentContainer">
        <div className="AuthShell AuthPageEnter">
          <div className="AuthCard">
            <div className="AuthLeftPane">
              <div className="AuthBrand">
                <img
                  src={require("./../images/iCareVillage_logo.webp")}
                  alt="iCareVillage"
                  className="AuthBrandLogo"
                />
                <div>
                  <div className="AuthBrandName">iCare Village</div>
                  <div className="AuthBrandTag">
                    Create an account to book care services, manage your calendar, and message providers.
                  </div>
                </div>
              </div>
              <div className="AuthHighlights">
                <div className="AuthHighlightItem">
                  <div className="AuthDot" />
                  <div>Book care visits in minutes</div>
                </div>
                <div className="AuthHighlightItem">
                  <div className="AuthDot" />
                  <div>Track appointments on your calendar</div>
                </div>
                <div className="AuthHighlightItem">
                  <div className="AuthDot" />
                  <div>Chat with care providers</div>
                </div>
              </div>
            </div>

            <div className="AuthRightPane">
              <RegistrationTitle />

              <div
                className="AuthPaneMotion"
                style={paneHeight ? { height: paneHeight } : undefined}
              >
                <div ref={paneRef} className="AuthPaneInner">
                  <Routes>
                <Route
                  path="/"
                  element={
                    <Registration1
                      registrationData={registrationData}
                      setRegistrationData={setRegistrationData}
                    />
                  }
                />
                <Route
                  path="/registration1"
                  element={
                    <Registration1
                      registrationData={registrationData}
                      setRegistrationData={setRegistrationData}
                    />
                  }
                />
                <Route
                  path="/registration2"
                  element={
                    <Registration2
                      registrationData={registrationData}
                      setRegistrationData={setRegistrationData}
                    />
                  }
                />
                <Route
                  path="/registration3"
                  element={<Registration3 registrationData={registrationData} />}
                />
                  </Routes>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Registration;
